import styled from "@emotion/styled";
import { verticalAlignedFlexbox } from "../config/commonCSS";

// Reusable flex container that aligns the flex children centrally used mostly with text and a svg
export const FlexContainer = styled.div`
  ${verticalAlignedFlexbox}
`;
